{
 "id": "sanctuary-monastery",
 "light": 0.55,
 "_note": "M10 Kanemori Sanctuary strip (x256-335), the ruined monastery (Shingan's lair): broken main hall, collapsed pagoda, cemetery, moss court, mossy cedars. Hand-placed temple buildings plus f* forest/mountain filler rectangles (face 0) generated to cover every other solid tile. Painters: client/src/hd-sanctuary.ts (kinds, roofs) and hd-sanctuary-place.ts (ground, edges, props, lights).",
 "rect": {
  "x": 256,
  "y": 0,
  "w": 80,
  "h": 44
 },
 "lamps": [],
 "buildings": [
  { "id": "mona-hall", "x": 294, "y": 10, "w": 18, "h": 18, "face": 4, "kind": "monaHall", "roof": "monaHallRoof" },
  { "id": "mona-pagoda", "x": 316, "y": 2, "w": 8, "h": 10, "face": 3, "kind": "monaPagoda", "roof": "monaPagodaRoof" },
  { "id": "mona-shed", "x": 284, "y": 6, "w": 8, "h": 6, "face": 2, "kind": "monaShed", "roof": "monaShedRoof" },
  { "id": "mona-wall", "x": 290, "y": 40, "w": 32, "h": 2, "face": 0, "kind": "sanctFill", "roof": "monaRuinWall" },
  { "id": "f1", "x": 258, "y": 0, "w": 38, "h": 6, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f2", "x": 296, "y": 0, "w": 40, "h": 2, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f3", "x": 296, "y": 2, "w": 20, "h": 8, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f4", "x": 324, "y": 2, "w": 12, "h": 10, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f5", "x": 258, "y": 6, "w": 26, "h": 6, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f6", "x": 292, "y": 6, "w": 4, "h": 4, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f7", "x": 292, "y": 10, "w": 2, "h": 2, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f8", "x": 312, "y": 10, "w": 4, "h": 2, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f9", "x": 258, "y": 12, "w": 24, "h": 24, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f10", "x": 328, "y": 12, "w": 8, "h": 24, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f11", "x": 282, "y": 28, "w": 8, "h": 16, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f12", "x": 326, "y": 28, "w": 2, "h": 16, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f13", "x": 258, "y": 36, "w": 24, "h": 8, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f14", "x": 328, "y": 36, "w": 8, "h": 8, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f15", "x": 325, "y": 40, "w": 1, "h": 4, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "f16", "x": 290, "y": 42, "w": 32, "h": 2, "face": 0, "kind": "sanctFill", "roof": "monaForest" },
  { "id": "wall-a", "x": 256, "y": 0, "w": 2, "h": 44, "face": 0, "kind": "sanctFill", "roof": "sanctWallOld" }
 ]
}
